var discount_data = {
    // 'ENFIN15S': {
    //     // Enfinitas s2 900
    //     'variant_id': [24650852204608],
    //     'quantity': 1,
    //     'percentage': 15,
    //     'fixed': 0
    // },
    // 'ENFIN10S': {
    //     // Enfinitas s3 900, s4 900
    //     'variant_id': [24650857939008, 30102560178240],
    //     'quantity': 1,
    //     'percentage': 10,
    //     'fixed': 0
    // }
};
$(document).on('click', '#cart_checkout', function (e) {
    if (!$(this).hasClass('auto-checkout-processed')) {
        e.preventDefault();
        var product_data = {};
        var discounts = {};
        var discount_code = '';
        var discount_value = 0;
        $('.cartItemWrap > div').each(function () {
            var $this = $(this);
            var variant_id;
            variant_id = $this.find('.velaQtyNum').attr('id').replace('updates_', '');
            product_data[variant_id] = [];
            product_data[variant_id]['qty'] = parseInt($this.find('.velaQtyNum').val());
            product_data[variant_id]['value'] = Number($this.find('.cartSubtotal').text().replace(/[^0-9.-]+/g,""));
        });
        $.each(discount_data, function (code, data) {
            var promoQty = 0;
            discounts[code] = 0;
            $.each(data.variant_id, function (index, pid) {
                if (product_data[pid]) {
                    promoQty += product_data[pid].qty;
                }
            });
            $.each(data.variant_id, function (index, pid) {
                if (product_data[pid]) {
                    var qty = product_data[pid].qty;
                    if (promoQty >= data.quantity) {
                        if (data.percentage === 0) {
                            discounts[code] += data.fixed * qty;
                        } else {
                            discounts[code] += (data.percentage/100) * product_data[pid].value;
                        }
                    }
                }
            });
        });
        $.each(discounts, function (code, value) {
            if (value > discount_value) {
                discount_value = value;
                discount_code = code;
            }
        });
        discount_code ? $('#discountCode').val(discount_code) : $('#discountCode').remove();
        $('#cart_checkout').addClass('auto-checkout-processed');
        $('#cart_checkout').trigger('click');
    }
});